import Vue from 'vue'
import Vuex from 'vuex'
import { Loading } from 'element-ui';

import axios from 'axios'
import { number } from 'echarts/lib/export';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.transformRequest = [function(data) {
    let src = ''
    for (let item in data) {
        src += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
    }
    return src
}]

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        show: false,
        // 当前页
        currentPage: 1,
        // 请求参数
        parameter: {
            p: 1,
            pagesize: 12,
            cate: 'all'
        },
        parameter2: {
            pagesize: 10000,
            cate: 'all'
        },
		metaInfo:{},
        // 数据列表
        dataList: [],
        // 总条数
        total: 0,
        //总页数
        pagescount: 0,
        //地图数据
        mapdata:[],
        // loadding
        loadingInstance: null,
        loadShow: true,
        // 一级导航
        nav: [{
                field: '跨境电商',
                category: [
                    '出口跨境电商',
                    '进口跨境电商',
                    '跨境电商服务商'
                ]
            },
            {
                field: '产业数字化',
                category: [
                    '综合B2B',
                    '钢铁电商',
                    '工业品电商',
                    '塑化电商',
                    '农业B2B',
                    '纺服B2B',
                    '汽车B2B',
                    '快消品B2B',
                    '餐饮B2B',
                    'B2B服务商',
                    '其他B2B',
					'云服务'
                ]
            },
            {
                field: '数字零售',
                category: [
                    '综合电商',
                    '社交电商',
                    '社区团购',
                    '直播电商',
                    '汽车电商',
                    '生鲜电商',
                    '二手电商',
                    '奢侈品电商',
                    '食品电商',
                    '美妆电商',
                    '农村电商',
                    '母婴电商',
                    '鲜花电商',
                    '酒水电商',
                    '服装电商',
                    '文玩电商',
                    '宠物电商',
                    '电商服务商',
                    '导购电商',
                    '数字藏品电商',
                    '无人零售',
					'品牌电商',
					'私域电商',
					'内容电商',
                ]
            },
            {
                field: '数字生活',
                category: [
                    '在线旅游',
                    '交通出行',
                    '家政服务',
                    '婚恋交友',
                    '在线票务',
                    '餐饮外卖',
                    '社区服务',
                    '共享经济',
                    '互联网家装',
                    '互联网房产',
					'互联网招聘',
                ]
            },
            {
                field: '数字教育',
                category: [
                    '综合',
                    '职业教育',
                    '早教',
                    '语言类',
                    '教育服务商',
                    '高等教育',
                    'steam教育',
                    'K12',
                    'MOOC',
                    '老年教育',
                ]
            },
            {
                field: '数字健康',
                category: [
                    '综合类',
                    '健康管理',
                    '母婴医疗',
                    '在线问诊',
                    '医药电商',
                    '互联网心理',
                    '运动健身',
                    '疫苗接种',
                    '在线挂号',
                    '互联网医院',
                    '互联网医美',
                    '医疗服务商',
                ]
            },
            {
                field: '物流科技',
                category: [
                    '物流网络',
                    '电商自建物流',
                    '第三方快递',
                    '智能快递柜',
                    '众包物流',
                    '仓储物流',
                    '货运O2O',
                    '同城配送',
                    '跨境物流',
                    '智能物流'
                ]
            },
            {
                field: '金融科技',
                category: [
                    '数字金融',
                    '保险',
                    '银行',
                    '征信',
                    '支付'
                ]
            },
			{
			    field: '数字文娱',
			    category: [
			        '演出票务',
			        '影音视频',
					'网络直播',
			    ]
			},
            // {
            //     field: '共享经济',
            //     category: [
            //         '综合类',
            //         '保险',
            //         '银行',
            //         '征信',
            //         '支付'
            //     ]
            // },
        ],
        // 二级导航
        nav2: [],
		//地区
		nav3:'',
		// [
			// {
			// 	province:'北京市',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'天津市',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'河北省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'山西省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'内蒙古自治区',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'辽宁省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'吉林省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'黑龙江省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'上海市',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'江苏省	',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'浙江省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'安徽省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'福建省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'江西省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'山东省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'河南省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'湖北省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'湖南省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'广东省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'广西壮族自治区',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'海南省',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'',
			// 	city:[
			// 		'',
			// 	]
			// },
			// {
			// 	province:'',
			// 	city:[
			// 		'',
			// 	]
			// },
		// ],
        // 竞品
        compet: [],
        industry:[],
        name: '',
    },
    mutations: {

		CAHNGE_META_INFO(state, metaInfo) { 
			state.metaInfo = metaInfo;
		},

        getShow(state) {
            setTimeout(() => {
                state.show = true
            }, 1000)
        },
        getmapdata (state, mapdata) {
            state.mapdata = mapdata
        },
        // 删除多余参数
        deleteParameter(state) {
            // delete state.parameter.cate
            delete state.parameter.a100
            delete state.parameter.a102
			delete state.parameter.a107
			delete state.parameter.a108
        },
        // 修改搜索参数
        modifyParameter(state, obj) {
            if (obj == undefined || obj.key == '') {
                delete state.parameter.name
                delete state.parameter.a107
                delete state.parameter.a108
            } else {
                switch (obj.type) {
                    case '平台':
                        state.parameter.name = obj.key
                        break;
                    case '省份':
                        state.parameter.a107 = obj.key
                        break;
                    case '城市':
                        state.parameter.a108 = obj.key
                        break;
                }
            }
        },
        // 获取数据
        getData(state, data) {
            state.total = parseInt(data.count)
            state.dataList = data.list
            state.pagescount = Number(data.pages) 
        },
        // 领域
        getField(state, radios) {
            state.parameter[radios[0]] = radios[1]
        },
        // 显示对应二级分类
        getField2(state, radio) {
            if (radio != '全部') {
                state.nav.forEach(item => {
                    if (item.field == radio) {
                        state.nav2 = item.category
                    }
                })
            } else {
                state.nav2 = []
            }
        },
        // 行业
        getCategory(state, radios) {
            // state.parameter[radios.a[0]] = radios.a[1]
            // state.parameter[radios.b[0]] = radios.b[1]
            const { a, b } = radios;
             // 处理一级
            if (a && a[1] && a[1] !== ''&& a[1] !=='全部') {
                state.parameter[a[0]] = a[1];
            } else {
                delete state.parameter[a[0]];
            }

            // 处理二级
            if (b && b[1] && b[1] !== '' && b[1] !== '全部') {
                state.parameter[b[0]] = b[1];
            } else {
                delete state.parameter[b[0]];
            }
        },
        // 首字母
		//地区 
		getCategory2 (state, radios) {
            const { c, d } = radios;

            // 处理省份/地区字段
            if (c && c[1] && c[1] !== '') {
                state.parameter[c[0]] = c[1];
            } else {
                delete state.parameter[c[0]];
            }

            // 处理城市字段
            if (d && d[1] && d[1] !== '') {
                state.parameter[d[0]] = d[1];
            } else {
                delete state.parameter[d[0]];
            }
			// if (radios.c != undefined) {
			// 	state.parameter[radios.c[0]] = radios.c[1]
			// 	if(radios.d != undefined) {
			// 		state.parameter[radios.d[0]] = radios.d[1]
			// 	}
            //     console.log(state.parameter,'radios.d')
			// } 
		},
        getLetter(state, letter) {
            if (letter != 'All') {
                state.parameter['a123'] = letter
            } else {
                delete state.parameter.a123
            }
        },
        // 分页
        getPage(state, val) {
            state.currentPage = val
            state.parameter.p = val
        },
        // 搜索
        getSearch(state, key) {
            var keyArr = []
            key.forEach(item => {
                keyArr.push(item.value)
            })

            state.searchList = []
            state.totalData.forEach(item => {
                if (keyArr.indexOf(item.name) != -1) {
                    state.searchList.push(item)
                }
            })
        },
        getName(state, name) {
            state.name = name
        },
        // 竞品
        getCompet(state, data) {
            state.compet = []

            var arr = data.list.filter(item => {
                return item.name != state.name
            })

            var len
            if (arr.length > 10) {
                len = 10
            } else {
                len = arr.length
            }

            for (var i = len; i > 0; i--) {
                var random = Math.round(Math.random() * (arr.length - 1));
                state.compet.push(arr[random])
                arr.splice(random, 1)
            }
        },
        // industrydata (state ,data) {

        // },
        // 创建加载
        openLoading(state) {
            this.dataList = []
            if (state.loadShow == true) {
                state.loadingInstance = Loading.service({
                    target: '#instance',
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'hsla(0, 0%, 100%, .95)',
                    customClass: 'load1'
                })
            }
        },
        // 关闭加载
        closeLoading(state) {
            setTimeout(() => {
                state.loadShow = false
                state.loadingInstance.close();
            }, 1000);
            setTimeout(() => {
                state.loadShow = true
            }, 1500)
        },
    },
    actions: {
        getAxios(context, parameter) {
            // 开启加载
            if (parameter.name != undefined || parameter.shares != undefined || parameter.p != undefined) {
                context.commit('openLoading')
            }
            // 每次点击按钮触发查询时都应该先清空之前的数据
            let combinedData = []; // 👈 改为初始为空
            // 获取数据
            axios({
                method: 'post',
                url: '/Index/new_data_json?dataid=13',
                data: parameter,
            }).then(res => {
                
                // res.data.list.sort((a, b) => b.a124 - a.a124).forEach(item => {
                res.data.list.forEach(item => {
                    Object.keys(item).forEach(key => {
                            // 初始化数据中的空数据和null
                            if (item[key] == '' || item[key] == null || item[key] == '-') {
                                item[key] = '暂无数据'
                            }
                        })
                        // 验证官网地址
                    if (item.a105 != '暂无数据' && item.a105.indexOf('http') == -1) {
                        item.a105 = 'http://' + item.a105
                    }
                })
                // console.log(res,'1')
                combinedData = res.data;
                // console.log(combinedData,'2')
                // 检查是否需要二次请求
                let needSecondRequest = false;
                let secondParameter = {...parameter};

                if (parameter.a107 && parameter.a107.includes("省")) {
                    needSecondRequest = true;
                    secondParameter.a107 = parameter.a107.replace("省", "");
                }
                
                if (parameter.a108 && parameter.a108.includes("市")) {
                    needSecondRequest = true;
                    delete secondParameter.a107;
                    secondParameter.a108 = parameter.a108.replace("市", "");
                }
                // if (parameter.a108 ) {
                //     delete secondParameter.a107;
                // }
                // 如果需要二次请求
                if (needSecondRequest) {
                    axios({
                        method: 'post',
                        url: '/Index/new_data_json?dataid=13',
                        data: secondParameter,
                    }).then(secondRes => {
                        // 清洗二次数据
                        secondRes.data.list.forEach(item => {
                            Object.keys(item).forEach(key => {
                                if (item[key] == '' || item[key] == null || item[key] == '-') {
                                    item[key] = '暂无数据'
                                }
                            })
                            if (item.a105 != '暂无数据' && item.a105.indexOf('http') == -1) {
                                item.a105 = 'http://' + item.a105
                            }
                        });
                        // console.log(secondRes,'4')
                        // 合并数据并去重（根据唯一标识符如 id 或 name）
                        const uniqueItems = new Set([...combinedData.list.map(item => JSON.stringify(item)), ...secondRes.data.list.map(item => JSON.stringify(item))]);
                        // console.log(uniqueItems,'5')
                        
                        combinedData.list = Array.from(uniqueItems).map(item => JSON.parse(item));
                        combinedData.count = Number(combinedData.count) + Number(secondRes.data.count);
                        // console.log(combinedData.pages,'7')
                        // combinedData.pages = Number(combinedData.pages) + Number(secondRes.data.pages);
                        combinedData.pages = Math.max(Number(combinedData.pages), Number(secondRes.data.pages));
                        // 存储合并且去重后的数据
                        if (parameter.name != undefined || parameter.shares != undefined || parameter.p != undefined) {
                            context.commit('getData', combinedData);
                        }

                        // 关闭加载
                        context.commit('closeLoading');
                    })
                    // .catch(err => {
                    //     // 添加提示信息：部分数据获取失败
                    //     console.error('部分数据获取失败：', err);
                    //     context.rootState._vm.$message.warning('部分数据获取失败，可能影响展示内容');
                    //     context.commit('closeLoading');
                    // });
                } else {
                    // 不需要二次请求的情况下直接存储数据
                    if (parameter.name != undefined || parameter.shares != undefined || parameter.p != undefined) {
                        context.commit('getData', res.data)
                    }

                    if (parameter.name != undefined) {
                        context.commit('getName', parameter.name)
                    }

                    // 竞品
                    if (parameter.name == undefined && parameter.p == undefined) {
                        context.commit('getCompet', res.data)
                    }

                    // 关闭加载
                    context.commit('closeLoading');
                }
            })
            // .catch(err => {
            //     console.error('First request failed:', err);
            //     // 添加提示信息：部分数据获取失败
            //     context.commit('closeLoading');
            // });
                // 存储数据
            //     if (parameter.name != undefined || parameter.shares != undefined || parameter.p != undefined) {
            //         context.commit('getData', res.data)
            //     }

            //     if (parameter.name != undefined) {
            //         context.commit('getName', parameter.name)
            //     }

            //     // 竞品
            //     if (parameter.name == undefined && parameter.p == undefined) {
            //         context.commit('getCompet', res.data)
            //     }
            //     // 类目统计
            //     if (parameter.pagesize == 1000) {
            //         context.commit('getmapdata', res.data.list)
            //     }
            //     // 关闭加载
            //     context.commit('closeLoading')
            // })
        },
		getmapAxios(context, parameter) {
		    // 开启加载
			context.commit('openLoading')
		    // 获取数据
		    axios({
		        method: 'post',
		        url: '/Index/new_data_json?dataid=13',
		        data: parameter,
		    }).then(res => {
		        
		        // res.data.list.sort((a, b) => b.a124 - a.a124).forEach(item => {
		        res.data.list.forEach(item => {
		            Object.keys(item).forEach(key => {
		                    // 初始化数据中的空数据和null
		                    if (item[key] == '' || item[key] == null || item[key] == '-') {
		                        item[key] = '暂无数据'
		                    }
		                })
		                // 验证官网地址
		            if (item.a105 != '暂无数据' && item.a105.indexOf('http') == -1) {
		                item.a105 = 'http://' + item.a105
		            }
		        })
		        // 存储数据
		        
		        //类目统计
		        if (parameter.pagesize == 10000) {
		            context.commit('getmapdata', res.data.list)
		        }
		        // 关闭加载
		        context.commit('closeLoading')
		    }).catch(err => {
                console.error('First request failed:', err);
		        context.commit('closeLoading');
		    });
		},
    },
    modules: {}
})